import api from '../services/api';
import { request_error } from './request_error';
import Cookies from 'universal-cookie';

import {
  SIGNOUT,
  EMAIL_CHANGED,
  PASSWORD_CHANGED,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  USER_IDENTIFIED,
  RESET_PASSWORD_SET,
  ERROR_PROP_SET,
  LOADING_TRUE,
  AUTH_TYPE,
  AUTH_COMPLETE,
  AUTH_USER
} from './types';

const cookies = new Cookies();
const SIGNIN_ENDPOINT = '/signin';
const SIGNUP_ENDPOINT = '/signup';

export const login = ({email, password, action}) => async dispatch => {
  dispatch({ type: LOADING_TRUE, payload: true });
  const token = cookies.get('jwt_token');

  if (token) {
    dispatch({ type: AUTH_TYPE, payload: 'signin' });
    await dispatch({ type: LOGIN_SUCCESS, payload: {
      token: token,
      email: email
    }});
    dispatch({ type: AUTH_COMPLETE });
  } else {
    try {
      if(action === 'signin') {
        dispatch({ type: AUTH_TYPE, payload: 'signin' });
        await auth(email, password, dispatch, SIGNIN_ENDPOINT);
      } else {
        dispatch({ type: AUTH_TYPE, payload: 'signup' });
        await auth(email, password, dispatch, SIGNUP_ENDPOINT);
      }
    } catch (e) {
      request_error(e);
      alert('An error occurred. There may be an issue with the network.');
      dispatch({ type: AUTH_COMPLETE });
    }
    dispatch({ type: AUTH_COMPLETE });

  }
  dispatch({ type: LOADING_TRUE, payload: false });
}

export const forgotPasswordTrigger = (email) => async dispatch => {
  const FORGOT_PASSWORD_ENDPOINT = `forgot_password`;
  try {
    let { data } = await api.post(`${FORGOT_PASSWORD_ENDPOINT}`, email);
  } catch (e) {
    request_error(e);
  }
}

export const resetPassword = ({email, token, newPassword, verifyPassword}) => async dispatch => {
  const RESET_PASSWORD_ENDPOINT = `reset_password`;
  try {
    let { data } = await api.post(`${RESET_PASSWORD_ENDPOINT}`, {
      email: email,
      token: token,
      newPassword: newPassword,
      verifyPassword: verifyPassword
    });
  } catch (e) {
    request_error(e);
  }
}

export const resetPasswordSettings = ({oldPassword, newPassword, verifyPassword}) => async dispatch => {
  const RESET_PASSWORD_SETTINGS_ENDPOINT = `reset_password_settings`;
  try {
    let { data } = await api.post(`${RESET_PASSWORD_SETTINGS_ENDPOINT}`, {
      oldPassword: oldPassword,
      newPassword: newPassword,
      verifyPassword: verifyPassword
    });

    return data;
  } catch (e) {
    request_error(e);

    return e;
  }
}

export const setUser = (userId) => {
  return { type: USER_IDENTIFIED, payload: userId };
}

export const setResetPassword = (params) => {
  return { type: RESET_PASSWORD_SET, payload: params };
}

export const setErrorProp = (errorProp) => {
  return { type: ERROR_PROP_SET, payload: errorProp };
}

const auth = async (email, password, dispatch, endpoint) => {
  try {
    let { data } = await api.post(endpoint, { email: email, password: password } );

    if ( data.token === undefined ) {
      return dispatch({ type: LOGIN_FAIL, payload: data })
    }

    await cookies.set('jwt_token', data.token, { path: '/' });

    await dispatch({ type: LOGIN_SUCCESS,
      payload: {
        token: data.token,
        email: email
      } });
    await dispatch({ type: AUTH_USER, payload: data.token});
  } catch (e) {
    request_error(e);
    return dispatch({ type: LOGIN_FAIL, payload: e.response.data })
  }
};

export const emailChanged = (text) => {
  return {
    type: EMAIL_CHANGED,
    payload: text
  };
};

export const passwordChanged = (text) => {
  return {
    type: PASSWORD_CHANGED,
    payload: text
  };
};

export const signout = () => {
  cookies.remove('jwt_token');
  return {
    type: SIGNOUT
  };
};

export const setLoading = (bool) => {
  return {
    type: LOADING_TRUE,
    payload: bool
  };
};
